import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'dateAgo',
  pure: true
})
export class DateAgoPipe implements PipeTransform {

  constructor(private translate: TranslateService) {} 

  transform(value: any, args?: any): any {
    var now = new Date();
    var utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
    if (value) {
        const seconds = Math.floor((+utc - +new Date(value)) / 1000);
        if (seconds < 29) // less than 30 seconds ago will show as 'Just now'
            return this.translate.instant('JUST_NOW')
        let intervals = {
            'YEAR': 31536000,
            'MONTH': 2592000,
            'WEEK' : 604800,
            'DAY': 86400,
            'HOUR': 3600,
            'MINUTE': 60,
            'SECOND': 1
        };
        let counter;
        for (const i in intervals) {
            counter = Math.floor(seconds / intervals[i]);
            if (counter > 0)
                if (counter === 1) {
                    return this.translate.instant(i+'_AGO', {counter}); // singular (1 day ago)
                } else {
                    return this.translate.instant(i+'S_AGO',  {counter});// plural (2 days ago)
                }
        }
    }
    return value;
}
}
